export const LOGIN = 'login/LOGIN'
export const LOGIN_SUCCESS = 'login/LOGIN_SUCCESS'
export const LOGOUT = 'login/LOGINOUT'
export const LOGOUT_SUCCESS = 'login/LOGOUT_SUCCESS'
export const REGISTER = 'login/REGISTER'
export const REGISTER_SUCCESS = 'register/REGISTER_SUCCESS'
export const GET_DRAFT_LIST = 'user/GET_DRAFT_LIST'
export const INIT_DRAFT_LIST = 'user/INIT_DRAFT_LIST'
export const GET_ARTICLE_LIST = 'user/GET_ARTICLE_LIST'
export const INIT_ARTICLE_LIST = 'user/INIT_ARTICLE_LIST'
export const GET_USER_INFO = 'user/GET_USER_INFO'
export const INIT_USER_INFO = 'user/INIT_USER_INFO'
export const GET_LIMIT_ARTICLE_LIST = 'user/GET_LIMIT_ARTICLE_LIST'
export const INIT_LIMIT_ARTICLE_LIST = 'user/INIT_LIMIT_ARTICLE_LIST'
